<div class="row filter-type-selection-header">
  <div class="col-6"></div>
  <div class="col-6 text-right">{{ filter.legalFormSelection?.length || 0 }} Selected</div>
</div>
<div class="row filter-type-selection-body">
  <div class="col-6">
    <p-table
      [value]="legalForms"
      (click)="formDirty = true"
      [(selection)]="filter.legalFormSelection"
      [scrollable]="true"
      (onRowSelect)="sortSelection(filter.legalFormSelection)"
      styleClass="legal-form-table"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3em" class="table-filter-row-header"><p-tableHeaderCheckbox></p-tableHeaderCheckbox>Select All</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr [pSelectableRow]="rowData" class="table-filter-row-data">
          <td><p-tableCheckbox (click)="formDirty = true" [value]="rowData"></p-tableCheckbox>{{ rowData.label }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="col-6">
    <p-tree
      class="selected-tree"
      (click)="formDirty = true"
      [value]="filter.legalFormSelection"
      [(selection)]="filter.legalFormSelection"
      selectionMode="multiple"
      selectionMode="checkbox"
      emptyMessage=" "
    ></p-tree>
  </div>
</div>
<!-- p-tree does not have implementation of value control accessor the hack below implements this -->
<fieldset ngModelGroup="legalFormSelection">
  <input type="hidden" [(ngModel)]="filter.legalFormSelection" name="legalFormSelection" #legalFormSelection="ngModel" required />
  <div class="row">
    <div class="col=12">
      <span class="help-block">
        <span *ngIf="formDirty && legalFormSelection.invalid"> Please select an option </span>
      </span>
    </div>
  </div>
</fieldset>
